export const getSummaryRejectedAction = (state, action) => {
	if (!action.meta.aborted) {
		state.success = false;
		state.isLoading = false;
		state.errorMessage = 'There was an error while fetching the vehicles.';
	}
};
